import React from 'react';

import baseStyles from '../../css/citations.module.css';
import { ErrorBoundary } from '../ErrorBoundary';
import Footer from '../Footer';
import Header from '../Header';
import HtmlHead from '../HtmlHead';
import layoutStyles from './layout.module.css';

type Props = {
  children: React.ReactNode
}

const Layout = (props: Props) => {

  const styles = { ...baseStyles, ...layoutStyles };

  return (
    <main className={`${styles.page}`}>
      <HtmlHead />
      <Header />
      <section className={`${styles.pageContainer}`}>
        <ErrorBoundary>
          {props.children}
        </ErrorBoundary>
      </section>
      <Footer />
    </main>
  )
}

export default Layout;
